// extracted by css-extract-rspack-plugin
export default {"toggle":"I1OpSp"};